import { render } from "./SpecimenMap.vue?vue&type=template&id=cb8132c0"
import script from "./SpecimenMap.vue?vue&type=script&lang=js"
export * from "./SpecimenMap.vue?vue&type=script&lang=js"
script.render = render

export default script